




























































import { Component, Vue, Provide } from "vue-property-decorator";
import { pagnition } from "@/utils/commonConfig";
import { timeFormat } from "@/utils/index.ts";

@Component({
  name: "CombinationProperty"
})
export default class CombinationProperty extends Vue {
  @Provide() private resultData: any = [];
  @Provide() private token: any;
  @Provide() private pageIndex: number = 1;
  @Provide() private pageSize: number = 20;
  @Provide() private pagerCount: number = 0;
  @Provide() private pagnition: any = pagnition;
  @Provide() private isGetTicketListActionDone: boolean = false;
  private created() {
    this.token = localStorage.getItem("token");
    this.getTicketList();
  }
  private handleCurrentChange(val: any) {
    this.pageIndex = Number(val);
    //展示表格数据
    this.getTicketList();
  }
  private handleSizeChange(val: any) {
    this.pageSize = Number(val);
    //展示表格数据
    this.getTicketList();
  }
  //点击上一页
  private handlePrevChange(val: any) {
    if (this.pageIndex > 0) {
      //展示表格数据
      this.getTicketList();
    }
  }
  //点击下一页
  private handleNextChange(val: any) {
    //展示表格数据
    this.getTicketList();
  }

  // 查询
  private async getTicketList() {
    const { getRepayCodeHistory }: any = await import(
      "@/request/paymentCodeHistory"
    );
    let arg = {
      pageIndex: this.pageIndex,
      pageSize: this.pageSize,
      orderId: this.$route.query.orderid
    };
    let res = await getRepayCodeHistory(arg, this);
    this.isGetTicketListActionDone = res ? res.loading : false;

    if (res) {
      let _result =
        typeof res.listList == "object"
          ? res.listList
          : JSON.parse(res.listList);
      if (_result) {
        _result.map((item: any) => {
          (item.paymentname = item.paymentname || "-"),
            (item.paymentcode = item.paymentcode || "-"),
            (item.amount = item.amount || "0"),
            (item.channelstatus = item.channelstatus || "-"),
            (item.createtime = timeFormat(item.createtime) || "-");
          item.invalidtime = timeFormat(item.invalidtime) || "-";
        });
        this.resultData = _result;
      }
      if (res.pageout || res.total) {
        this.pagerCount = res.total ? res.total : res.pageout.total;
      }
    }
  }
}
